import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=965e688c&scoped=true&"
import script from "./Room.vue?vue&type=script&lang=js&"
export * from "./Room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965e688c",
  null
  
)

export default component.exports